import { BodyWeight } from "@/components/Weight";
import React from 'react';

export const WeightOverview = () => {
    return <BodyWeight />;
};